import { service as request } from '@/libs/request'
import { Message } from 'element-ui'

// 获取公共形象列表
export function commonPersonListApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getPersonList', params)
}

// 创建数字人视频任务
export function createVideoTaskApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/createVideo', params)
}

// 获取视频详情
export function getVideoDetailApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getVideoDetail', params)
}

// 下载数字人视频（后端代理，返回二进制流；规避第三方 CDN 跨域）
export function downloadVideoFileApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/downloadVideo', params, {
    responseType: 'blob',
    timeout: 120000
  })
}

// 我的数字人作品列表
export function worksListApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getMyWorks', params)
}

// 批量删除数字人作品
export function deleteWorksApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/batchDeleteWorks', params)
}

// 创建定制数字人形象
export function createPersonkApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/createPerson', params)
}

// 我的数字人形象列表
export function getMyPersonListApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getMyPersonList', params)
}

// 删除我的数字人形象
export function deletePersonApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/deletePerson', params)
}

// 视频上传
export function uploadVideoApi (params) {
  return request.post('user/api.userinfo/uploadVideo', params)
}

// 算力配置（各项收费标准 + 余额）
export function getPointsConfigApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getPointsConfig', params)
}

// 预估本次生成算力消耗
export function calculatePointsApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/calculatePoints', params)
}

// 创建定制声音（音色训练/克隆）
export function createCustomAudioApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/createCustomAudio', params)
}

// 我的定制声音列表
export function getMyAudioListApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/getMyAudioList', params)
}

// 删除定制声音
export function deleteAudioApi (params) {
  return request.post('useragent/api.ChanjingDigitalHuman/deleteAudio', params)
}